<template>
    <!-- 教学管理 -->
    <div id="education">
        <el-grade></el-grade>
    </div>
</template>

<script>
//  引入班级管理页面
import Grade from "@/components/pay/Grade/Grade";

export default {
    name: "pay",
    components: {
        "el-grade": Grade,
    },
    data() {
        return {
            tabindex: "0",
        };
    },
    created() {
        this.$global.activeMenu = "2-3"; //不激活左侧
    },
    mounted() {},
    methods: {
        setIndex(e) {
            let me = this;
            me.tabindex = e.index;
        },
    },
};
</script>

<style lang="scss">
@import "../../assets/less/global.less";
@import "../../assets/css/icon.css";
@import "../../assets/css/app.css";
#grade {
    .pay-tip {
        border: 1px solid #ffca85;
        display: flex;
        align-items: center;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/pay/pay.vue